// client/src/neetjee_guru/components/libraryManagement/mutations.js
import gql from "graphql-tag";

export const ADD_BOOK = gql`
  mutation addBook($input: BookInput!) {
    addBook(input: $input) {
      id
      title
      author
      isbn
      category
      language
      price
      subject
      total_copies
      available_copies
      copies {
        id
        accession_no
        rack_location
        status
      }
      institute_id
      branch_id
    }
  }
`;

export const UPDATE_BOOK = gql`
  mutation updateBook($id: Int!, $input: BookInput!) {
    updateBook(id: $id, input: $input) {
      id
      title
      author
      isbn
      category
      language
      price
      subject
      total_copies
      available_copies
      copies {
        id
        accession_no
        rack_location
        status
      }
      institute_id
      branch_id
    }
  }
`;

export const DELETE_BOOK = gql`
  mutation deleteBook($id: Int!, $institute_id: Int!, $branch_id: Int!) {
    deleteBook(id: $id, institute_id: $institute_id, branch_id: $branch_id)
  }
`;

export const ADD_BOOK_COPY = gql`
  mutation addBookCopy($book_id: Int!, $accession_no: String!, $rack_location: String, $status: String, $institute_id: Int!, $branch_id: Int!) {
    addBookCopy(book_id: $book_id, accession_no: $accession_no, rack_location: $rack_location, status: $status, institute_id: $institute_id, branch_id: $branch_id) {
      id
      book_id
      accession_no
      rack_location
      status
      institute_id
      branch_id
    }
  }
`;

export const DELETE_BOOK_COPY = gql`
  mutation deleteBookCopy($copy_id: Int!, $institute_id: Int!, $branch_id: Int!) {
    deleteBookCopy(copy_id: $copy_id, institute_id: $institute_id, branch_id: $branch_id)
  }
`;

export const ISSUE_BOOK = gql`
  mutation issueBook($borrower_type: String!, $borrower_id: Int!, $copy_id: Int!, $loan_type: String!, $institute_id: Int!, $branch_id: Int!) {
    issueBook(borrower_type: $borrower_type, borrower_id: $borrower_id, copy_id: $copy_id, loan_type: $loan_type, institute_id: $institute_id, branch_id: $branch_id) {
      id
      borrower_type
      borrower_id
      borrower_name
      borrower_code
      copy_id
      accession_no
      book_id
      book_title
      issue_date
      due_date
      status
    }
  }
`;

export const ISSUE_MULTIPLE_BOOKS = gql`
  mutation issueMultipleBooks($borrower_type: String!, $borrower_id: Int!, $copy_ids: [Int!]!, $loan_type: String!, $institute_id: Int!, $branch_id: Int!) {
    issueMultipleBooks(borrower_type: $borrower_type, borrower_id: $borrower_id, copy_ids: $copy_ids, loan_type: $loan_type, institute_id: $institute_id, branch_id: $branch_id) {
      id
      borrower_type
      borrower_id
      borrower_name
      borrower_code
      copy_id
      accession_no
      book_id
      book_title
      issue_date
      due_date
      status
    }
  }
`;

export const RETURN_BOOK = gql`
  mutation returnBook($issue_id: Int!, $paid_amount: Float!, $fine_type: String, $fine_amount: Float, $status: String, $institute_id: Int!, $branch_id: Int!, $return_date: String) {
    returnBook(issue_id: $issue_id, paid_amount: $paid_amount, fine_type: $fine_type, fine_amount: $fine_amount, status: $status, institute_id: $institute_id, branch_id: $branch_id, return_date: $return_date) {
      id
      borrower_name
      borrower_code
      book_title
      accession_no
      issue_date
      due_date
      return_date
      overdue_days
      fine_amount
      status
    }
  }
`;

export const RENEW_LOAN = gql`
  mutation renewBookIssue($issue_id: Int!, $institute_id: Int!, $branch_id: Int!) {
    renewBookIssue(issue_id: $issue_id, institute_id: $institute_id, branch_id: $branch_id) {
      id
      due_date
      renew_count
      status
    }
  }
`;

export const RECORD_FINE_PAYMENT = gql`
  mutation recordFinePayment($fine_id: Int!, $amount: Float!, $institute_id: Int!, $branch_id: Int!) {
    recordFinePayment(fine_id: $fine_id, amount: $amount, institute_id: $institute_id, branch_id: $branch_id) {
      id
      fine_amount
      paid_amount
      balance_amount
      status
    }
  }
`;

export const WAIVE_FINE = gql`
  mutation waiveFine($fine_id: Int!, $reason: String, $institute_id: Int!, $branch_id: Int!) {
    waiveFine(fine_id: $fine_id, reason: $reason, institute_id: $institute_id, branch_id: $branch_id) {
      id
      fine_amount
      paid_amount
      balance_amount
      status
      waive_reason
    }
  }
`;

export const UPDATE_LIBRARY_SETTINGS = gql`
  mutation updateLibrarySettings($input: LibrarySettingsInput!) {
    updateLibrarySettings(input: $input) {
      library_name
      timings
      fine_per_day
      max_borrow_days
      max_books
      max_renewals
      semester_borrow_days
      max_semester_books
      institute_id
      branch_id
    }
  }
`;

export const UPDATE_BOOK_COPY = gql`
  mutation updateBookCopy($copy_id: Int!, $accession_no: String, $rack_location: String, $status: String, $institute_id: Int!, $branch_id: Int!) {
    updateBookCopy(copy_id: $copy_id, accession_no: $accession_no, rack_location: $rack_location, status: $status, institute_id: $institute_id, branch_id: $branch_id) {
      id
      book_id
      accession_no
      rack_location
      status
      institute_id
      branch_id
    }
  }
`;
